/* eslint-disable @typescript-eslint/no-empty-function */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IError } from '../../../../../base/api';
import { SetFieldParams } from '../../../../../base/interfaces/params';
import { SignUpStep } from '../../enums';

export interface Fields {
    phone: string;
    password: string;
    agreeTerms: boolean;
    smsCode?: string;
}

export interface SignUpState {
    step: SignUpStep;
    fields: Fields;
    errors: IError | null;
    shouldScrollToError: boolean;
}

const fieldsInitialState: Fields = {
    password: '',
    phone: '',
    agreeTerms: false,
};

const initialState: SignUpState = {
    step: SignUpStep.RegistrationInfo,
    fields: fieldsInitialState,
    errors: null,
    shouldScrollToError: false,
};

export const signUpSlice = createSlice({
    name: 'worker-app__signup',
    initialState,
    reducers: {
        clearData: (state) => {
            state.step = SignUpStep.RegistrationInfo;
            state.fields = fieldsInitialState;
            state.errors = null;
            state.shouldScrollToError = false;
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setStep: (state, action: PayloadAction<SignUpStep>) => {
            state.step = action.payload;
        },
        setField: (state, action: PayloadAction<SetFieldParams>) => {
            state.fields = {
                ...state.fields,
                [action.payload.id]: action.payload.value,
            };
            if (state.errors === null) {
                return;
            }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { [action.payload.errorGroupName || action.payload.id]: removedError, ...errors } = state.errors;
            state.errors = errors;
        },
        setErrors: (state, action: PayloadAction<IError>) => {
            if (state.errors) {
                state.errors = {
                    ...state.errors,
                    ...action.payload,
                };
            } else {
                state.errors = action.payload;
            }
        },
        setShouldScrollToError: (state, action: PayloadAction<boolean>) => {
            state.shouldScrollToError = action.payload;
        },
        submitSignUp: () => {},
        submitChangeConfirmationValue: {
            reducer: () => {},
            prepare: (newValue: string, recaptchaToken: string | null, callback: () => void) => ({
                payload: { newValue, recaptchaToken, callback },
            }),
        },
    },
});

export const signUpActions = signUpSlice.actions;
export const signUpReducer = signUpSlice.reducer;
